export default "__VITE_ASSET__431e4a75__"